import Slider from "react-slick"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"
import FriendRowMobile from './FriendRowMobile'

const FriendsMobileSlide = ({friends}) => {

      const settings = {
            dots: false,
            infinite: true,
            speed: 600,
            slidesToShow: 5,
            slidesToScroll: 1,
            variableWidth: true,
            autoplay: true,
            autoplaySpeed: 2000,
            cssEase: 'ease-in-out',
            responsive: [
                  {
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 4,
                      slidesToScroll: 1,
                      initialSlide: 2
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1
                    }
                  }
            ]
      }

      return (
            <div>
                  <Slider {...settings}>
                        {
                              friends.map((friend) => (
                                    <FriendRowMobile friend={friend} key={friend.name} />  
                              ))
                        }
                  </Slider>
            </div>
      )
}

export default FriendsMobileSlide
